// Every market TikTok's Commercial Music Library ranks separately (checked against the live API, Oct 2026; China, Russia
// and India answer too but TikTok isn't available there). Trends are fetched per market only when someone opens it.
export const TREND_REGIONS = [
  { id: 'GB', label: 'United Kingdom', country: 'the UK', group: 'Europe' },
  { id: 'AT', label: 'Austria', country: 'Austria', group: 'Europe' },
  { id: 'BE', label: 'Belgium', country: 'Belgium', group: 'Europe' },
  { id: 'CZ', label: 'Czechia', country: 'Czechia', group: 'Europe' },
  { id: 'DK', label: 'Denmark', country: 'Denmark', group: 'Europe' },
  { id: 'FI', label: 'Finland', country: 'Finland', group: 'Europe' },
  { id: 'FR', label: 'France', country: 'France', group: 'Europe' },
  { id: 'DE', label: 'Germany', country: 'Germany', group: 'Europe' },
  { id: 'GR', label: 'Greece', country: 'Greece', group: 'Europe' },
  { id: 'HU', label: 'Hungary', country: 'Hungary', group: 'Europe' },
  { id: 'IS', label: 'Iceland', country: 'Iceland', group: 'Europe' },
  { id: 'IE', label: 'Ireland', country: 'Ireland', group: 'Europe' },
  { id: 'IT', label: 'Italy', country: 'Italy', group: 'Europe' },
  { id: 'NL', label: 'Netherlands', country: 'the Netherlands', group: 'Europe' },
  { id: 'NO', label: 'Norway', country: 'Norway', group: 'Europe' },
  { id: 'PL', label: 'Poland', country: 'Poland', group: 'Europe' },
  { id: 'PT', label: 'Portugal', country: 'Portugal', group: 'Europe' },
  { id: 'RO', label: 'Romania', country: 'Romania', group: 'Europe' },
  { id: 'ES', label: 'Spain', country: 'Spain', group: 'Europe' },
  { id: 'SE', label: 'Sweden', country: 'Sweden', group: 'Europe' },
  { id: 'CH', label: 'Switzerland', country: 'Switzerland', group: 'Europe' },
  { id: 'UA', label: 'Ukraine', country: 'Ukraine', group: 'Europe' },
  { id: 'US', label: 'United States', country: 'the US', group: 'Americas' },
  { id: 'AR', label: 'Argentina', country: 'Argentina', group: 'Americas' },
  { id: 'BR', label: 'Brazil', country: 'Brazil', group: 'Americas' },
  { id: 'CA', label: 'Canada', country: 'Canada', group: 'Americas' },
  { id: 'CL', label: 'Chile', country: 'Chile', group: 'Americas' },
  { id: 'CO', label: 'Colombia', country: 'Colombia', group: 'Americas' },
  { id: 'MX', label: 'Mexico', country: 'Mexico', group: 'Americas' },
  { id: 'PE', label: 'Peru', country: 'Peru', group: 'Americas' },
  { id: 'AU', label: 'Australia', country: 'Australia', group: 'Asia-Pacific' },
  { id: 'ID', label: 'Indonesia', country: 'Indonesia', group: 'Asia-Pacific' },
  { id: 'JP', label: 'Japan', country: 'Japan', group: 'Asia-Pacific' },
  { id: 'MY', label: 'Malaysia', country: 'Malaysia', group: 'Asia-Pacific' },
  { id: 'NZ', label: 'New Zealand', country: 'New Zealand', group: 'Asia-Pacific' },
  { id: 'PH', label: 'Philippines', country: 'the Philippines', group: 'Asia-Pacific' },
  { id: 'SG', label: 'Singapore', country: 'Singapore', group: 'Asia-Pacific' },
  { id: 'KR', label: 'South Korea', country: 'South Korea', group: 'Asia-Pacific' },
  { id: 'TH', label: 'Thailand', country: 'Thailand', group: 'Asia-Pacific' },
  { id: 'VN', label: 'Vietnam', country: 'Vietnam', group: 'Asia-Pacific' },
  { id: 'EG', label: 'Egypt', country: 'Egypt', group: 'Middle East & Africa' },
  { id: 'IL', label: 'Israel', country: 'Israel', group: 'Middle East & Africa' },
  { id: 'KE', label: 'Kenya', country: 'Kenya', group: 'Middle East & Africa' },
  { id: 'NG', label: 'Nigeria', country: 'Nigeria', group: 'Middle East & Africa' },
  { id: 'SA', label: 'Saudi Arabia', country: 'Saudi Arabia', group: 'Middle East & Africa' },
  { id: 'ZA', label: 'South Africa', country: 'South Africa', group: 'Middle East & Africa' },
  { id: 'TR', label: 'Turkey', country: 'Turkey', group: 'Middle East & Africa' },
  { id: 'AE', label: 'United Arab Emirates', country: 'the UAE', group: 'Middle East & Africa' },
] as const;

/** The codes of those markets: the TikTok trends picker offers only list markets TikTok ranks (support #238). */
export const TREND_REGION_CODES: readonly string[] = TREND_REGIONS.map((r) => r.id);
